import React from "react"
import { Tabs, Tab } from "react-bootstrap"
import LevelSetup from "./levelSettings/LevelSetup"
import TerminalModalSetup from "./terminalModalSettings/TerminalModalSetup"


const MasterDataSettings = () => {
  return (
    <Tabs
      defaultActiveKey="levels"
      id="uncontrolled-tab-example"
      className="mb-3"
      justify
    >
      <Tab eventKey="levels" title={"Level Setup"}>
        <LevelSetup />
      </Tab>
      <Tab eventKey="TerminalModels" title={"Terminal Models"}>
        <TerminalModalSetup/>
      </Tab>
    </Tabs>
  )
}

export default MasterDataSettings
